export default __webpack_public_path__ + "static/media/m-31.ac69e6c8.svg";